"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartCrop = void 0;
var validator_1 = require("../validation/validator");
var geometry_base_1 = require("./geometry-base");
/**
 * @description Crops the image intelligently using width and height options.
 * @param width
 * @param height
 * @constructor SmartCrop
 */
var SmartCrop = /** @class */ (function (_super) {
    __extends(SmartCrop, _super);
    function SmartCrop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'scrop';
        return _this;
    }
    /**
     * @returns {{params: string, error: *}}
     */
    SmartCrop.prototype.serialize = function () {
        var badWidth = validator_1.validator.numberIsNotGreaterThan('width', this.width, 1);
        var badHeight = validator_1.validator.numberIsNotGreaterThan('height', this.height, 1);
        if (badWidth || badHeight) {
            return {
                params: null,
                error: new Error([badWidth, badHeight].filter(function (msg) { return msg; }).join(',')),
            };
        }
        var out = this.name + "/w_" + this.width + ",h_" + this.height;
        return {
            params: out,
            error: null,
        };
    };
    return SmartCrop;
}(geometry_base_1.GeometryBase));
exports.SmartCrop = SmartCrop;
//# sourceMappingURL=smartcrop.js.map